import { ErrorResponse } from "@robe/core-api/baseApiRequest";
import { AuthError } from "./AuthError";
import { BaseError, isBaseErrorParams } from "./BaseError";
import { InternalServerError } from "./InternalServerError";
import { NotFoundError } from "./NotFoundError";
import { XcoreError } from "./XcoreError";

export const handleXcoreError =
  (getError: (url: string, res: Response, errs?: Record<string, string[]>, errText?: string) => XcoreError) =>
    async (url: string, res: Response) => {
      const plainResError = !res.headers.get("content-type")?.includes("json");

      throw getError(url, res, !plainResError ? (await res.json())?.errors : undefined, plainResError ? await res.text() : undefined);
    };

/**
 * @throws {AuthError | NotFoundError | InternalServerError}
 */
export const handleError = async (res: Response, url: string) => {
  process.env.NEXT_PUBLIC_DEBUG === "true" && res.status !== 200 && console.log({ status: res.status, url, res });

  if (res.status === 401 || res.status === 403) {
    throw new AuthError(url, res);
  }

  // 404 error will still be recognized as `BaseError` if there is specific 404 error mapping for specific EP.
  if (res.status === 404 || res.status === 204) {
    let error = null;

    try {
      error = await res.json();
    } catch (e) {
      throw new NotFoundError(url, res);
    }

    throw new NotFoundError(url, res, error);
  }

  // eslint-disable-next-line @typescript-eslint/no-extra-parens
  if (res.status === 400 || res.status === 402 || (res.status > 404 && res.status < 500)) {
    let error = null;

    try {
      error = await res.json();
    } catch (e) {
      throw new InternalServerError(url, res);
    }

    if (error && isBaseErrorParams(error)) {
      throw new BaseError(error);
    }
  }

  if (res.status >= 500) {
    try {
      const error = await res.json();

      if (error as ErrorResponse) {
        throw new InternalServerError(url, res, error);
      }

      throw new InternalServerError(url, res);
    } catch (e) {
      // Throw plain res if res not json
      throw new InternalServerError(url, res);
    }
  }

  return res;
};
